import * as action from './meetingAction'
import { default as actionType } from './meetingActionType'
import { default as reducer } from './meetingReducer'

export const MEETING = {
  action,
  actionType,
  reducer
}
